import styled from 'styled-components';
import { colorDanger } from 'globalStyles';

export const ErrorMessage = styled.p`
  margin-top: 0.5em;
  color: ${colorDanger};
`;

export const ErrorText = styled.span`
  margin-left: 0.33em;
`;
